import React from "react";
import { Col, Form, Ratio, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const Profile = () => {
  const user = useSelector((state) => state.user.user);
  return (
    <>
      <Row>
        <Col>
          <Table responsive hover>
            <tr>
              <td>Name :</td>
              <td className="fw-bold">{user[0].name}</td>
              <td>Email :</td>
              <td className="fw-bold">{user[0].email}</td>
            </tr>
            <tr>
              <td>Mobile :</td>
              <td className="fw-bold">{user[0].phone}</td>
              <td>Gender :</td>
              <td className="fw-bold">{user[0].gender}</td>
            </tr>
            <tr>
              <td>Degree :</td>
              <td className="fw-bold">{user[0].degree}</td>
              <td>College :</td>
              <td className="fw-bold">{user[0].college}</td>
            </tr>
            <tr>
              <td>Branch :</td>
              <td className="fw-bold">{user[0].branch}</td>
              <td>Year :</td>
              <td className="fw-bold">{user[0].yearofgraduation}</td>
            </tr>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col></Col>
      </Row>
    </>
  );
};

export default Profile;
